import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { Formik } from 'formik';
import * as Yup from 'yup';
import { Alert, Box, Button, Collapse, FormHelperText, Grid, IconButton, TextField, Typography } from '@mui/material';
import axios from 'axios';
import ApiLink from 'API';
import CloseIcon from '@mui/icons-material/Close';
import MessageBox from 'ui-component/MessageBox';
const ResetPassword = ({ open, setOpen }) => {
    const handleClose = () => {
        setOpen(false);
    };
    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    const [AlertBox, setAlertBox] = useState({
        open: false,
        message: '',
        severity: 'error'
    });

    return (
        <div>
            <Dialog
                // fullScreen
                fullWidth
                maxWidth="xs"
                open={open}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    <Typography variant="caption" sx={{ color: '#00c853' }}>
                        Reset Password
                    </Typography>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <div id="app-message-box" />
                    <Collapse in={AlertBox.open}>
                        <Alert
                            sx={{ padding: '10px', mb: 2 }}
                            // variant="outlined"
                            severity={AlertBox.severity}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertBox({ ...AlertBox, open: false });
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {AlertBox.message}
                        </Alert>
                    </Collapse>
                    <DialogActions id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                        <Formik
                            initialValues={{
                                // customerID: '',
                                password1: '',
                                password2: ''
                            }}
                            validationSchema={Yup.object().shape({
                                password1: Yup.string().max(255, 'characters is max 255').required('required'),
                                password2: Yup.string().max(255, 'characters is max 255').required('required')
                            })}
                            onSubmit={async (values, { setErrors, setSubmitting, resetForm }) => {
                                try {
                                    // alert(JSON.stringify(values, null, 2));
                                    if (values.password1 !== values.password2) {
                                        setAlertBox({
                                            open: true,
                                            message: 'Password not match',
                                            severity: 'error'
                                        });
                                        resetForm();
                                    } else {
                                        await axios
                                            .put(
                                                ApiLink + '/api/users/reset',
                                                { password: values.password1 },
                                                {
                                                    withCredentials: true,
                                                    headers: {
                                                        token: localStorage.getItem('token')
                                                    }
                                                }
                                            )
                                            .then((res) => {
                                                // console.log(res.data);
                                                resetForm();
                                                // setAlertBox({
                                                //   open: true,
                                                //   message: "Change password is successfully",
                                                //   severity: "success",
                                                // });
                                                MessageBox.open({
                                                    title: 'Success',
                                                    content: <Typography variant="body1">Change password is successfully</Typography>,
                                                    buttons: [{ name: 'OK', handler: () => setOpen(false) }]
                                                });
                                                //   setOpen(false);
                                                // setAlertBox({ open: true, message: 'Add success', severity: 'success' });
                                            })
                                            .catch((error) => {
                                                try {
                                                    if (error.response.status === 400 || error.response.status === 500) {
                                                        setAlertBox({
                                                            open: true,
                                                            message: error.response.data.msg,
                                                            severity: 'error'
                                                        });
                                                    } else {
                                                        setAlertBox({
                                                            open: true,
                                                            message: error.response.statusText,
                                                            severity: 'error'
                                                        });

                                                        // console.log(error.response.statusText);
                                                    }
                                                } catch (error) {
                                                    setAlertBox({
                                                        open: true,
                                                        message: error,
                                                        severity: 'error'
                                                    });
                                                }
                                            });
                                    }

                                    setSubmitting(false);
                                } catch (err) {
                                    console.error(err);

                                    setErrors({ submit: err.message });
                                    setSubmitting(false);
                                }
                            }}
                        >
                            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
                                <form noValidate onSubmit={handleSubmit}>
                                    <Grid container spacing={1}>
                                        {/* <Grid item xs={12} sm={12} md={4} lg={4} align="center"></Grid> */}
                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={12}>
                                                    <TextField
                                                        fullWidth
                                                        label="New Password"
                                                        // margin="dense"
                                                        name="password1"
                                                        type="password"
                                                        defaultValue=""
                                                        onBlur={handleBlur}
                                                        value={values.password1}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                    />
                                                    {touched.password1 && errors.password1 && (
                                                        <FormHelperText error id="standard-weight-helper-text--register">
                                                            {errors.password1}
                                                        </FormHelperText>
                                                    )}
                                                </Grid>

                                                <Grid item xs={12} sm={12}>
                                                    <TextField
                                                        fullWidth
                                                        label="Confirm Password"
                                                        // margin="dense"
                                                        name="password2"
                                                        type="password"
                                                        defaultValue=""
                                                        onBlur={handleBlur}
                                                        value={values.password2}
                                                        onChange={handleChange}
                                                        variant="outlined"
                                                    />
                                                    {touched.password2 && errors.password2 && (
                                                        <FormHelperText error id="standard-weight-helper-text--register">
                                                            {errors.password2}
                                                        </FormHelperText>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <Box sx={{ mt: 2 }}>
                                                <Button
                                                    disableElevation
                                                    disabled={isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Reset Password
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </DialogActions>
                    {/* <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                        {[...new Array(50)]
                            .map(
                                () => `Cras mattis consectetur purus sit amet fermentum.
Cras justo odio, dapibus ac facilisis in, egestas eget quam.
Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
Praesent commodo cursus magna, vel scelerisque nisl consectetur et.`
                            )
                            .join('\n')}
                    </DialogContentText> */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    {/* <Button onClick={handleClose}>Save</Button> */}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ResetPassword;
